import { useAuthStore } from '../stores/auth-store';
import { useShallow } from 'zustand/react/shallow';

/**
 * Convenience hook that selects commonly used values from the auth store.
 * Uses shallow equality to prevent unnecessary re-renders.
 */
export function useAuth() {
  return useAuthStore(
    useShallow((state) => ({
      user: state.user,
      isAuthenticated: state.isAuthenticated,
      login: state.login,
      logout: state.logout,
      restoreSession: state.restoreSession,
    }))
  );
}
